import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Stack, Typography } from "@mui/material";
import { type FC } from "react";

import { RichTooltip } from "~/components/UI/RichTooltip";
import { TradeOnPlatformCard } from "~/feature/event/components/MarketCalculator/components/TradeOnPlatformCard";
import type { IAggregatedEvent } from "~/types/event";

import { useTradeOnCards } from "./useTradeOnCards";

interface ITradeOnProps {
  event: IAggregatedEvent;
}

const TRADE_ON_TOOLTIP =
  "All calculations and returns are indicative only. Actual returns may vary due to liquidity, slippage, timing, and fees (not included).";

export const TradeOn: FC<ITradeOnProps> = ({ event }) => {
  const cards = useTradeOnCards();

  return (
    <Stack
      sx={{
        gap: 1,
        width: "100%"
      }}>
      <Stack
        sx={{
          gap: 0.5,
          width: "100%",
          flexDirection: "row"
        }}>
        <Typography
          variant="caption"
          sx={{
            fontWeight: 600,
            textTransform: "uppercase",
            color: "text.secondary"
          }}>
          Trade on
        </Typography>
        <RichTooltip title={TRADE_ON_TOOLTIP}>
          <InfoOutlinedIcon fontSize="small" color="disabled" />
        </RichTooltip>
      </Stack>
      {cards.map((card) => (
        <TradeOnPlatformCard
          key={card.market.id}
          market={card.market}
          event={event}
          calculatedData={card.calculatedData}
          settledElsewhereWarning={card.settledElsewhereWarning}
        />
      ))}
    </Stack>
  );
};
